document.addEventListener('DOMContentLoaded', function () {
  const variantSelector = document.querySelector('[name="id"]');
  const weightSpan = document.getElementById('variant-weight');
  const strengthSpan = document.getElementById('product-strength');

  const variantMetafieldsScript = document.getElementById('variant-metafields');
  const productMetafieldsScript = document.getElementById('product-metafields');

  if (!variantSelector || !weightSpan || !strengthSpan || !variantMetafieldsScript || !productMetafieldsScript) return;

  const variantMetafields = JSON.parse(variantMetafieldsScript.textContent);
  const productMetafields = JSON.parse(productMetafieldsScript.textContent);

  // Sätt styrka från produktens metafält
  strengthSpan.textContent = productMetafields.styrka || "–";

  function updateWeight(variantId) {
    const variantData = variantMetafields[variantId];
    if (variantData && variantData.vikt) {
      weightSpan.textContent = variantData.vikt;
    } else {
      // Fallback till produktens vikt
      weightSpan.textContent = productMetafields.vikt || "–";
    }
  }

  // Initial uppdatering
  updateWeight(variantSelector.value);

  // Vid variantbyte
  variantSelector.addEventListener('change', function () {
    updateWeight(this.value);
  });
});
